<template>
  <div class="table-body">
    <div class="performance-header">
      <b-select class="select-wrapper" v-model="term1">
        <option selected value="month">月間</option>
        <option selected value="week">週間</option>
      </b-select>
      <b-select class="select-wrapper" v-model="term2">
        <option selected value="this">{{term1 == 'month' ? '今月' : '今週'}}</option>
        <option selected value="last">{{term1 == 'month' ? '先月' : '先週'}}</option>
        <option selected value="before-last">{{term1 == 'month' ? '先々月' : '先々週'}}</option>
      </b-select>
      <span style="padding-top: 8px;">{{ displayDate }}</span>
      <b-pagination
        style="width: 50%; margin-left: auto; padding-bottom: 4px; font-size: 14px;"
        class="pagination"
        :total="filteredChatbots.length"
        :current.sync="pages"
        :per-page="perPage">
        <b-pagination-button
          slot-scope="props"
          :page="props.page"
          tag="button">
          {{ props.page.number }}
        </b-pagination-button>
        <b-pagination-button
          slot="previous"
          slot-scope="props"
          :page="props.page"
          tag="button">
          ＜
        </b-pagination-button>
        <b-pagination-button
          slot="next"
          slot-scope="props"
          :page="props.page"
          tag="button">
            ＞
        </b-pagination-button>
      </b-pagination>
    </div>
    <div class="t-scroll">
      <table class="performance-table disp-scroll" v-if="chatbots.length > 0">
        <thead>
          <tr>
            <th colspan="2">
              {{headers[0]}}
            </th>
            <th colspan="5">
              {{headers[1]}}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(chatbot, i) in filteredChatbots">
            <template v-if="i < pages * perPage && i >= (pages - 1) * perPage">
              <tr :key="i + '-bots'">
                <!-- 1: icon & name -->
                <td style="min-width: 320px; width: 25%;">
                  <Tooltip :message="tooltipMessage(chatbot)">
                    <img class="chatbot-icon" :src="getIconURL(chatbot)" @click="movePartsEdit(chatbot)"/>
                  </Tooltip>
                  <p class="chatbot-title">{{chatbot.name}}</p>
                </td>
                <!-- 2: tag & date -->
                <td class="tag-l">
                  <!-- タグリスト -->
                  <ChatBotTags
                    :chatbot="chatbot"
                    :isNew="false"/>
                  <p style="color: transparent;"> - </p>
                  <p style="font-size: 11px;">作成日：{{createdBot(chatbot)}}</p>
                </td>
                <!-- 3: 稼働状況  -->
                <td>
                  <p>稼働状況</p>
                  <p v-if="isOnBot(chatbot)">稼働中</p>
                  <p v-else>未稼働</p>
                </td>
                <!-- 4: 出勤時間  -->
                <td>
                  <p>出勤時間</p>
                  <p>{{usedTime(chatbot)}}</p>
                </td>
                <!-- 5: 対応数 -->
                <td>
                  <p>対応数</p>
                  <p>（人）</p>
                  <p>
                    <portal-target :name="'modal-taiosu-' + chatbot.bot_id"></portal-target>
                  </p>
                </td>
                <!-- 6: 完了者数 -->
                <td>
                  <p>完了者数</p>
                  <p>（人）</p>
                  <p>
                    <portal-target :name="'modal-kanryosu-' + chatbot.bot_id"></portal-target>
                  </p>
                </td>
                <!-- 7: 完了後アクション -->
                <td>
                  <p>完了後アクション</p>
                  <div style="display: flex; justify-content: space-around; align-items: center;">
                    <p style="width: 64px;">離脱率</p>
                    <p style="width: 64px; font-size: 12px;">離脱点ﾊﾟｰﾂ</p>
                    <p style="width: 64px;">ロボ閉</p>
                    <p style="width: 64px;">ﾌﾞﾗｳｻﾞ閉</p>
                    <p style="width: 64px; font-size: 12px;">別ロボ遷移</p>
                  </div>
                  <PerformanceData :chatbot="chatbot" :period="period"/>
                </td>
              </tr>
              <tr :key="i + '-bots'" v-if="!chatbot.is_GOAL">
                <td colspan="7">
                  <b-message type="is-warning" has-icon>
                    <p><small>{{chatbot.name}}</small></p>
                    ロボのパーツにGOAL設定がされていないため、離脱率、完了数などの数値が正確に検出できておりません。
                    GOAL設定を<a style="color: red !important; text-decoration: underline !important;" @click="movePartsEdit(chatbot)">編集画面</a>より設定していただくとより正確な数値が取得できるようになります。
                  </b-message>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState }    from 'vuex'
import ChatBotTags     from '@/components2/Common/Screen/organisms/ChatBotTags'
import PerformanceData from '@/components/Performance/organisms/PerformanceData'
import Tooltip             from '@/components/atoms/tooltips/Tooltip'
import moment from 'moment'
export default {
  name: 'PerformanceTable',
  componentName: 'PerformanceTable',
  components: {
    ChatBotTags,
    PerformanceData,
    Tooltip
  },
  props: {
    chatbots: {
      type: Array,
      require: true
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapState('chatbot', ['chatbotHistory', 'scenarioHistory']),
    ...mapState('sitemap', ['sitemapRootList', 'sitemapEmploymentList']),
    filteredChatbots () {
      let bots = []
      for (let cb of this.chatbots) if (!cb.is_archive) bots.push(cb)
      return bots
    },
    displayDate () {
      let str = moment(this.period.begin).format('YYYY/MM/DD') + ' ～ '
      if (this.term2 == 'this') return str + moment(this.period.end).format('YYYY/MM/DD')
      else return str + moment(this.period.end).subtract(1, 'days').format('YYYY/MM/DD')
    }
  },
  data () {
    return {
      headers : [
        '基本',
        '稼働情報'
      ],
      pages: 1,
      perPage: 30,
      term1: 'month',
      term2: 'this',
      period: {
        begin: new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0),
        end: new Date(),
      },
    }
  },
  watch: {
    pages () {
      let el = document.querySelector('.performance-table')
      el.scrollTo(0, 0)
    },
    term1 () {
      this.term2 = ''
    },
    term2 () {
      if (this.term2 == '') this.term2 = 'this'
      else this.updatePeriod()
    },
  },
  methods: {
    // シナリオ編集画面へ
    movePartsEdit (chatbot) {
      this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
      this.$store.dispatch('chatbot/getScenario', { companyid: chatbot.group, scenarioName: chatbot.scenario_name })
      this.$store.dispatch('chatbot/selectChatbot', chatbot)
      this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + chatbot.scenario_name)
    },
    // ロボが起動しているかどうか
    isOnBot (chatbot) {
      // ロボの起動設定チェック
      if (!chatbot.chatbot_mini) {
        // ミニロボを持っていない場合
        for (const root of this.sitemapRootList) {
          for (const sitemap of root.node_list) {
            for (const robo of sitemap.apply_robo_list) {
              if (robo.data.bot_id === chatbot.bot_id) {
                return true
              }
            }
          }
        }
        for (const employment of this.sitemapEmploymentList) {
          for (const robo of employment.apply_robo_list) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
      } else if (chatbot.chatbot_mini.length < 1) {
        // ミニロボを持っていない場合
        for (const root of this.sitemapRootList) {
          for (const sitemap of root.node_list) {
            for (const robo of sitemap.apply_robo_list) {
              if (robo.data.bot_id === chatbot.bot_id) {
                return true
              }
            }
          }
        }
        for (const employment of this.sitemapEmploymentList) {
          for (const robo of employment.apply_robo_list) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
      } else {
        // ミニロボを持っている場合
        for (const mini of chatbot.chatbot_mini) {
          for (const root of this.sitemapRootList) {
            for (const sitemap of root.node_list) {
              for (const robo of sitemap.apply_minirobo_list) {
                if (robo.data.bot_id === mini.bot_id) {
                  return true
                }
              }
            }
          }
          for (const employment of this.sitemapEmploymentList) {
            for (const robo of employment.apply_minirobo_list) {
              if (robo.data.bot_id === mini.bot_id) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    // 初期読み込み
    init () {
      this.$store.dispatch('sitemap/getSitemapRecruitListAll')
      this.$store.dispatch('sitemap/getSitemapRootList')
      this.$store.dispatch('chatbot/getScenarioHistory', null)
      this.$store.dispatch('chatbot/getChatBotHistory', null)
    },
    // icon 表示
    getIconURL (chatbot) {
      if (chatbot.icon_data) {
        return chatbot.icon_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    tooltipMessage (chatbot) {
      return chatbot.name + 'のシナリオ編集画面へ'
    },
    // 初回作成
    createdBot (chatbot) {
      let at = new Date(chatbot.created_at)
      let year = at.getFullYear()
      let month = at.getMonth() + 1
      let day = at.getDate()
      return '\'' + year%100 + '/' + month + '/' + day
    },
    updatePeriod () {
      let back = 0
      if (this.term2 == 'this') back = 0
      if (this.term2 == 'last') back = 1
      if (this.term2 == 'before-last') back = 2
      if (this.term1 == 'month') {
        this.period = {
          begin: new Date(new Date().getFullYear(), new Date().getMonth() - back, 1, 0, 0, 0),
          end: (back==0 ? new Date() : new Date(new Date().getFullYear(), new Date().getMonth() - (back-1), 1, 0, 0, 0)),
        }
      }
      if (this.term1 == 'week') {
        const last_sunday = moment().day(0)
        this.period = {
          begin: new Date(last_sunday.year(), last_sunday.month(), last_sunday.date() - (7*back), 0, 0, 0),
          end: (back==0 ? new Date() : new Date(last_sunday.year(), last_sunday.month(), last_sunday.date() - (7*(back-1)), 0, 0, 0)),
        }
      }
    },
    usedTime (chatbot) {
      let mlsec = this.calcUsedTime(chatbot)
      let sec = Math.floor(mlsec / 1000)

      // 1分未満の場合
      if (sec < 60) return sec + '秒'
      let min = Math.floor(sec / 60)
      // 1時間未満の場合
      if (min < 60) return min + '分'
      else return Math.floor(min / 60) + '時間'
    },
    isCheckMonth (day, now) {
      return (now.getFullYear() === day.getFullYear() && now.getMonth() === day.getMonth())
    },
    calcUsedTime (chatbot) {
      let startDate     = null
      let operatingTime = 0
      
      // chatbotHistoryはback側でソート済み
      const histories = this.chatbotHistory.filter((h) => (chatbot.bot_id == h.chatbot || chatbot.bot_id == h.chatbotmini))

      //設置履歴を取得
      for (const history of histories) {
        const date = new Date(history.changed_at)
        if (date < this.period.begin) {
          // 期間より前
          if (history.is_start) startDate = this.period.begin
          else startDate = null

        } else if (date < this.period.end) {
          // 期間内
          if (history.is_start && !startDate) startDate = date
          if (!history.is_start && startDate) operatingTime += (date - startDate)

        } else {
          // 期間より後
          break
        }
      }

      if (startDate) {
        // 期間終了時点で稼働中である
        operatingTime += (this.period.end - startDate)
      }

      return operatingTime
    }
  }
}
</script>

<style lang="scss" scoped>
.performance-header {
  display: flex;

  .select-wrapper {
    margin-bottom: 4px;
    margin-right: 8px;
    /deep/ .select {
      height: 35px;
      width: 100px;
      select {
        height: 100%;
        width: 100%;
      }
    }
  }
}

.table-body {
  display: block;
  padding: 24px;
  height: calc(100vh - 100px);
  width: auto;
  .t-scroll {
    height: calc(100% - 20px);
    width: 100%;
  }
  .performance-table {
    height: 100%;
    width: auto !important;
    position: relative;
    -ms-overflow-style: none;
    th {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 3;
      background: #FFB7FF;
    }
  }
  table td:not([align]), table th:not([align]) {
    text-align: center;
  }
  table {
    border-collapse: collapse;
    margin: 0 auto;
    display: block;
    height: 100%;
    table-layout: fixed;
  }
  td,th {
    min-width: 100px;
    padding: 8px;
    margin: auto;
    font-size: smaller;
  }
  td {
    text-align: left;
    padding: 8px;
    height: 80px;
  }
  table tr:nth-child(odd) {
    background:#ffeeff;
  }
  table tr:nth-child(even) {
    background:#fafafa;
  }
  .chatbot-icon {
    width:  48px;
    height: 48px;
    object-fit: cover;
    border-radius: 50%;
    margin: auto;
    background: white;
    border: solid thin #ccc;
  }
  .chatbot-title {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    white-space: pre-wrap;
    height: 20px;
  }
}
.tag-l {
  max-width: 128px;
  /deep/ .tag-c {
    flex-wrap: wrap !important;
    overflow: auto !important;
  }
}
.pagination {
  /deep/ .pagination-list {
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Performance/PerformanceTable.vue